import * as yup from 'yup';
import { SolarFarmSchema } from './SolarFarmSchema';
import { OrgSchema } from './OrgSchema';
import { InspectionSchema } from './InspectionSchema';

export const OrderSchema = yup.object({
  exit_status: yup.number(),
  order: yup.object({
    id: yup.number(),
    uuid: yup.string(),
    priority: yup.number(),
    org_id: yup.number(),
    creator_id: yup.number(),
    updator_id: yup.number(),
    order_type: yup.string().nullable(),
    status: yup.number(),
    substatus: yup.string().nullable(),
    claimed_by_user_id: yup.number().nullable(),
    channel: yup.string().nullable(),
    comments_to_channel: yup.string().nullable(),
    comments_from_channel: yup.string().nullable(),
    submitted_tsecs: yup.number().nullable(),
    delivered_tsecs: yup.number().nullable(),
    created_tsecs: yup.number().nullable(),
    updated_tsecs: yup.number().nullable(),
    contract_type: yup.string().nullable(),
    special_instructions: yup.string().nullable(),
    internal_comments: yup.string().nullable(),
    processing_hold: yup.boolean(),
    data_received_tsecs: yup.number().nullable(),
    client_org_id: yup.number().nullable(),
    solar_farm_uuid: yup.string().nullable(),
    source_order_uuid: yup.string().nullable(),
    requested_delivery_date: yup.number().nullable(),
    turnkey_services: yup.boolean(),
    requested_flight_date: yup.number().nullable(),
    site_contact_uuid: yup.string().nullable(),
    pilot_contact_uuid: yup.string().nullable(),
    estimated_delivery_date: yup.number().nullable(),
    estimated_flight_date: yup.number().nullable(),
    data_collection_status: yup.string().nullable(),
    data_collection_org_id: yup.number().nullable(),
    accounting_invoice_number: yup.string().nullable(),
    pm_user_id: yup.number().nullable(),
    mailing_list: yup.string().nullable(),
    sales_project_id: yup.number().nullable(),
    data_collection_manager_id: yup.number().nullable(),
    email_updates_enabled: yup.boolean().nullable(),
    flight_start_date: yup.number().nullable(),
    flight_end_date: yup.number().nullable(),
    id_report_provider: yup.string().nullable(),
    image_skip_rate: yup.number().nullable().defined(),
    org: OrgSchema.defined(),
    inspections: yup.array().of(InspectionSchema.defined()),
    channel_instructions: yup.array().defined(),
    services: yup
      .array()
      .of(
        yup
          .object({
            id: yup.number(),
            uuid: yup.string(),
            name: yup.string(),
            description: yup.string(),
            default_selected: yup.boolean(),
          })
          .defined(),
      )
      .defined(),
    upload_requests: yup
      .array()
      .of(
        yup
          .object({
            id: yup.number(),
            uuid: yup.string(),
            creator_id: yup.number(),
            org_id: yup.number(),
            access_token_id: yup.number(),
            name: yup.string(),
            notify: yup.boolean(),
            created_tsecs: yup.number(),
            updated_tsecs: yup.number().nullable(),
            status: yup.number(),
            access_token: yup
              .object({
                id: yup.number(),
                creator_id: yup.number(),
                access_token: yup.string(),
                created_tsecs: yup.number(),
                is_active: yup.boolean(),
                job_id: yup.string().nullable(),
                foreign_uuid: yup.string().nullable(),
              })
              .defined(),
            upload_sessions: yup
              .array()
              .of(
                yup
                  .object({
                    id: yup.number(),
                    creator_id: yup.number(),
                    created_tsecs: yup.number(),
                    url: yup.string(),
                    org_id: yup.number(),
                    current_file: yup.number(),
                    file_total: yup.number(),
                    name: yup.string(),
                    upload_attempt: yup.number(),
                  })
                  .defined(),
              )
              .defined(),
            url: yup.string(),
          })
          .defined(),
      )
      .defined(),
    accounting_info_items: yup.array().defined(),
    channel_orgs: yup.array().of(OrgSchema).defined(),
    client_orgs: yup.array().of(OrgSchema).defined(),
    solar_farm: SolarFarmSchema.defined(),
    site_contact: yup.string().nullable(),
    pilot_contact: yup.string().nullable(),
    pm_user: yup.string().nullable(),
    zones: yup.array(yup.string()).nullable(),
  }),
});

export type OrderResponse = yup.InferType<typeof OrderSchema>;
export type Order = OrderResponse['order'];
